import TableHead from './TableHead';
import Trow from './Trow';

import classes from './UsersTable.module.scss';

export default function UsersTable() {
  return (
    <table className={classes.table}>
      <TableHead />
      <tbody>
        <Trow
          Raw={1}
          Username={'me'}
          Company={'blue'}
          Address={1245}
          AccessLevel={0}
        />
        <Trow
          Raw={2}
          Username={'you'}
          Company={'red'}
          Address={123456}
          AccessLevel={0}
        />
        <Trow
          Raw={3}
          Username={'he'}
          Company={'yellow'}
          Address={8745}
          AccessLevel={0}
        />
        <Trow
          Raw={4}
          Username={'she'}
          Company={'black'}
          Address={3454}
          AccessLevel={0}
          leftStyle={{
            borderBottomLeftRadius: '20px',
          }}
          rightStyle={{
            borderBottomRightRadius: '20px',
          }}
        />
      </tbody>
    </table>
  );
}
